$(document).ready(function(){
  $('body .cccscc-cell').each(function(){
   $('.cccs-cell-first .Grid').append($(this));
  })
})




$(".product-submit-box").click(function(){
if($("#checkto_addproduct").length<=0)return  
  let input_status=$("#checkto_addproduct").prop("checked");
  if(input_status){
    $(".openboxtag_tishi").hide();
    $(this).removeClass("disabled");
  }
  else{
     $(".openboxtag_tishi").show();
      $(this).addClass("disabled");
  } 
})

$("#checkto_addproduct").change(function(){
  let input_status=$(this).prop("checked");
  
  if(input_status){
    $(".openboxtag_tishi").hide();
    $(".product-submit-box").removeClass("disabled");
  }
  else{
     $(".openboxtag_tishi").show();
     $(".product-submit-box").addClass("disabled");
  }
})


$(".open_agree_detail b").click(function(){
  $(".popover").fadeToggle();
})